import { Review } from '@virginexperiencedays/products';

export function allOneStar(reviews: Review[]): boolean {
  return reviews.every((review) => review.rating === 1);
}
